module.exports = "<app-subheader></app-subheader>\n<app-faq-content></app-faq-content>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/faq/faq.component.html
// module id = ../../../../../src/app/faq/faq.component.html
// module chunks = 0